import {
  Box,
  Container,
  Grid,
  Stack,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SubscriptionCard from "../../components/cards/SubscriptionCard";
import SubscriptionData from "../../json/SubscriptionData.json";
import { getRoleWiseSubscription } from "../../services/subservicesFn";
import AppLoader from "./../../components/apploader/index";
import { useSnackbar } from "../../lib/context/snackbarContext";
import { t } from "i18next";
import { useSelector } from "react-redux";

const Subscription = () => {
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState("company");
  const [subscriptionByRole, setSubscriptionByRole] = useState([]);
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  const getData = async (roleee) => {
    try {
      setIsLoading(true);
      let resultt = await getRoleWiseSubscription(roleee);
      if (resultt.status == 200 || resultt.status == 201) {
        setSubscriptionByRole(resultt.data.data);
      } else {
        showSnackbar(resultt?.data?.message, "error");
        setSubscriptionByRole([]);
      }
    } catch (error) {
      showSnackbar(error?.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData(value);
  }, [value]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container
      maxWidth={"lg"}
      sx={{ mb: 20, position: "relative", zIndex: 999 }}
    >
      <AppLoader isVisible={isLoading} />
      <Stack textAlign={"center"} mt={"90px"} pt={"56px"} mb={10} spacing={2}>
        <Typography
          variant="heading_pr"
          component={"h1"}
          color={"text.white"}
          lineHeight={"normal"}
          textTransform={"capitalize"}
        >
          {t("businessPlans")}
        </Typography>
        {/* <Typography variant="heading_sec" component={"p"} color={"text.white"}>
          Here is a comparison chart of us with the Ipsum tool, but at the end
          we win!
        </Typography> */}

        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          sx={{ marginBottom: "30px", background: "#fff" }}
        >
          <Tab value="company" label={t("company")} />
          <Tab value="supplier" label={t("supplier")} />
          <Tab value="worker" label={t("worker")} />
        </Tabs>
      </Stack>

      <Grid container>
        {subscriptionByRole?.map((item, ind) => {
          return (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              position={"relative"}
              // top={{ md: item.name === "premium" ? "-55px" : 0 }}
              sx={{
                "&:hover": {
                  top: "-55px",
                  transition: "all 0.5s ease-out",
                },
              }}
              //   height={item.type === "Premium" && "130%"}
            >
              <SubscriptionCard
                key={ind}
                data={item}
                currentLanguage={currentLanguage}
              />
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default Subscription;
